export const FETCH_DASHBOARD_LOADING = 'FETCH_DASHBOARD_LOADING';
export const FETCH_DASHBOARD_SUCCESS = 'FETCH_DASHBOARD_SUCCESS';
export const FETCH_DASHBOARD_FAILURE = 'FETCH_DASHBOARD_FAILURE';
export const FETCH_MISSIONS_FAILURE = 'FETCH_MISSIONS_FAILURE';
export const FETCH_MISSIONS_LOADING = 'FETCH_MISSIONS_LOADING';
export const FETCH_MISSIONS_SUCCESS = 'FETCH_MISSIONS_SUCCESS';
